import { reactive } from 'vue'

export const store = reactive(
    {
        id: null,
        title: "Add Calendars To Your Bundle",
        calendarsTotalQty: 0,
        priceByQty: 0,
        bandleProductLists: [

        ],
        prices: {
            // set after change imprint tab
            tier: null,
            // set if change qty, and in imprintAppSummary as we need update if imprint tab changed
            priceByQty: null,
        },
        
        inputProductData: {
            fullJson: null,
            colorVariants: {
                handle: null,
                data: null
            },
            sizeVariants: {
                handle: null,
                data: null
            },
            sizeUpcharge: {},
            imprintVariants: {
                handle: null,
                data: null
            },
            /* by default 1, seted after done init*/
            qtyIncrement: null,
            minOrderQty: null,
            associatedIds: null,
        }
    }
)